export default __webpack_public_path__ + "assets/fca7825ef06d76d29ca83ff95a8885eb.jpg";